import solicitudes from './solicitudes.js';
import { getProductosEmpresa } from './productosSolicitudes.js';

const { getClientesbyEmpresa } = require('./clienteSolicitudes.js');
const { getUsuariosEmpresa } = require('./usuariosSolicitudes');
const { getDatosEmpresas } = require('./empresaSolicitudes.js');
const { getDatosSucursal } = require('./sucursalesSolicitudes.js');

// ✅ FUNCIONES PRINCIPALES CORREGIDAS PARA USAR RUTAS DEL BACKEND
export const clientesReportes = async (id_usuario) => {
    try {
        const token = localStorage.getItem('auth');
        const url = `${solicitudes.homeUrl}/reporte/clientes`;
        const response = await fetch(url, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status}`);
        }

        const data = await response.json();
        console.log("✅ Clientes cargados desde API backend:", data);
        return data || [];
    } catch (error) {
        console.error('❌ Error al obtener clientes para reportes:', error);
        // Fallback al método original
        try {
            const datos = await getClientesbyEmpresa(id_usuario);
            let clientes = [];

            datos.forEach(d => {
                clientes.push({
                    id: d.id_cliente,
                    nombre: d.nombre_completo
                });
            });
            
            return clientes;
        } catch (fallbackError) {
            console.error('❌ Error en fallback de clientes:', fallbackError);
            return [];
        }
    }
}

export const reportesEmpleados = async (id_usuario, esCeo) => {
    try {
        const token = localStorage.getItem('auth');
        const url = `${solicitudes.homeUrl}/reporte/empleados`;
        const response = await fetch(url, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status}`);
        }

        const data = await response.json();
        console.log("✅ Empleados cargados desde API backend:", data);
        return data || [];
    } catch (error) {
        console.error('❌ Error al obtener empleados para reportes:', error);
        // Fallback al método original
        try {
            let empleados = [];
            let datos = [];
            
            if(esCeo){
                datos = await getUsuariosEmpresa(id_usuario);
            } else {
                datos = await solicitudes.fetchRegistrosAuth(`/reporte/usuarios-sucursal/${id_usuario}`);
            }

            datos.forEach(d => {
                empleados.push({
                    id: d.id_usuario,
                    nombre: `${d.nombre} ${d.apellido}` 
                });
            });
            
            return empleados;
        } catch (fallbackError) {
            console.error('❌ Error en fallback de empleados:', fallbackError);
            return [];
        }
    }
}

export const sucursalReportes = async (id_usuario) => {
    try {
        const token = localStorage.getItem('auth');
        const url = `${solicitudes.homeUrl}/reporte/sucursales`;
        const response = await fetch(url, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status}`);
        }

        const data = await response.json();
        console.log("✅ Sucursales cargadas desde API backend:", data);
        return data || [];
    } catch (error) {
        console.error('❌ Error al obtener sucursales para reportes:', error);
        // Fallback al método original
        try {
            const datos = await solicitudes.fetchRegistrosAuth(`/sucursales/empresa/${id_usuario}`);
            let sucursal = [];

            datos.forEach(d => {
                sucursal.push({
                    id: d.id_sucursal,
                    nombre: d.nombre_administrativo
                });
            });
            
            return sucursal;
        } catch (fallbackError) {
            console.error('❌ Error en fallback de sucursales:', fallbackError);
            return [];
        }
    }
}

export const reportesProductos = async (id_usuario, esCeo) => {
    let productos = [];
    let datos = [];
    
    try {
        if(esCeo){
            datos = await getProductosEmpresa(id_usuario);
        } else {
            datos = await solicitudes.fetchRegistrosAuth(`/reporte/productos/${id_usuario}`);
        }

        datos.forEach(d => {
            productos.push({
                id: d.id_producto,
                nombre: d.nombre
            });
        });
        
        return productos;
    } catch (error) {
        console.error('❌ Error al obtener productos para reportes:', error);
        return [];
    }
}

// Reportes tradicionales de ventas
export const getRegistrosEmpleados = async (id_usuario, fechaInicio, fechaFin, incluirCanceladas = false) => {
    try {
        const params = incluirCanceladas ? '?incluir_canceladas=true' : '';
        const response = await solicitudes.fetchRegistrosAuth(`/reporte/reporte-empleados/${id_usuario}/${fechaInicio}/${fechaFin}${params}`);
        return response;
    } catch (error) {
        console.error(error);
        throw 'Ocurrió un error al obtener registros de empleados';
    }
}

export const getRegistrosClientes = async (id_usuario, fechaInicio, fechaFin, incluirCanceladas = false) => {
    try {
        const params = incluirCanceladas ? '?incluir_canceladas=true' : '';
        const response = await solicitudes.fetchRegistrosAuth(`/reporte/reporte-clientes/${id_usuario}/${fechaInicio}/${fechaFin}${params}`);
        return response;
    } catch (error) {
        console.error(error);
        throw 'Ocurrió un error al obtener registros de clientes';
    }
}

export const getRegistrosSucursales = async (id_usuario, fechaInicio, fechaFin, incluirCanceladas = false) => {
    try {
        const params = incluirCanceladas ? '?incluir_canceladas=true' : '';
        const response = await solicitudes.fetchRegistrosAuth(`/reporte/reporte-sucursales/${id_usuario}/${fechaInicio}/${fechaFin}${params}`);
        return response;
    } catch (error) {
        console.error(error);
        throw 'Ocurrió un error al obtener registros de sucursales';
    }
}

// Desgloses de reportes tradicionales
export const getRegistrosEmpleadosDesglose = async (id_usuario, fechaInicio, fechaFin, incluirCanceladas = false) => {
    try {
        const params = incluirCanceladas ? '?incluir_canceladas=true' : '';
        const response = await solicitudes.fetchRegistrosAuth(`/reporte/reporte-empleado-desglose/${id_usuario}/${fechaInicio}/${fechaFin}${params}`);
        return response;
    } catch (error) {
        console.error(error);
        throw 'Ocurrió un error al obtener desglose de empleado';
    }
}

export const getRegistrosClienteDesglose = async (id_cliente, fechaInicio, fechaFin, incluirCanceladas = false) => {
    try {
        const params = incluirCanceladas ? '?incluir_canceladas=true' : '';
        const response = await solicitudes.fetchRegistrosAuth(`/reporte/reporte-cliente-desglose/${id_cliente}/${fechaInicio}/${fechaFin}${params}`);
        return response;
    } catch (error) {
        console.error(error);
        throw 'Ocurrió un error al obtener desglose de cliente';
    }
}

export const getRegistrosSucursalDesglose = async (id_sucursal, fechaInicio, fechaFin, incluirCanceladas = false) => {
    try {
        const params = incluirCanceladas ? '?incluir_canceladas=true' : '';
        const response = await solicitudes.fetchRegistrosAuth(`/reporte/reporte-sucursal-desglose/${id_sucursal}/${fechaInicio}/${fechaFin}${params}`);
        return response;
    } catch (error) {
        console.error(error);
        throw 'Ocurrió un error al obtener desglose de sucursal';
    }
}

// ✅ CORRECCIÓN: Productos Más Vendidos
export const getProductosMasVendidos = async (id_usuario, fechaInicio, fechaFin, limite = 20, incluirCanceladas = false, id_sucursal = null) => {
    try {
        const params = new URLSearchParams({
            limite: limite.toString(),
            incluir_canceladas: incluirCanceladas.toString()
        });

        // ✅ AGREGAR id_sucursal si existe
        if (id_sucursal) {
            params.append('id_sucursal', id_sucursal);
        }

        const response = await solicitudes.fetchRegistrosAuth(`/reporte/productos-mas-vendidos/${id_usuario}/${fechaInicio}/${fechaFin}?${params}`);
        return response;
    } catch (error) {
        console.error('Error al obtener productos más vendidos:', error);
        throw 'Ocurrió un error al obtener productos más vendidos';
    }
};

// ✅ CORRECCIÓN: Clientes Frecuentes
export const getClientesFrecuentes = async (id_usuario, fechaInicio, fechaFin, limite = 20, id_sucursal = null) => {
    try {
        const params = new URLSearchParams({
            limite: limite.toString()
        });

        // ✅ AGREGAR id_sucursal si existe
        if (id_sucursal) {
            params.append('id_sucursal', id_sucursal);
        }

        const response = await solicitudes.fetchRegistrosAuth(`/reporte/clientes-frecuentes/${id_usuario}/${fechaInicio}/${fechaFin}?${params}`);
        return response;
    } catch (error) {
        console.error('Error al obtener clientes frecuentes:', error);
        throw 'Ocurrió un error al obtener clientes frecuentes';
    }
};

export const getInventarioBajoStock = async (id_usuario, limite = 50) => {
    try {
        const params = new URLSearchParams({
            limite: limite.toString()
        });

        const response = await solicitudes.fetchRegistrosAuth(`/reporte/inventario-bajo-stock/${id_usuario}?${params}`);
        return response;
    } catch (error) {
        console.error('Error al obtener inventario bajo stock:', error);
        throw 'Ocurrió un error al obtener inventario bajo stock';
    }
};

// ✅ CORRECCIÓN: Ventas por Hora
export const getVentasPorHora = async (id_usuario, fechaInicio, fechaFin, id_sucursal = null) => {
    try {
        const params = new URLSearchParams();
        
        // ✅ AGREGAR id_sucursal si existe
        if (id_sucursal) {
            params.append('id_sucursal', id_sucursal);
        }

        const queryString = params.toString() ? `?${params}` : '';
        const response = await solicitudes.fetchRegistrosAuth(`/reporte/ventas-por-hora/${id_usuario}/${fechaInicio}/${fechaFin}${queryString}`);
        return response;
    } catch (error) {
        console.error('Error al obtener ventas por hora:', error);
        throw 'Ocurrió un error al obtener ventas por hora';
    }
};

// ✅ CORRECCIÓN: Métodos de Pago
export const getReporteMetodosPago = async (id_usuario, fechaInicio, fechaFin, id_sucursal = null) => {
    try {
        const params = new URLSearchParams();
        
        // ✅ AGREGAR id_sucursal si existe
        if (id_sucursal) {
            params.append('id_sucursal', id_sucursal);
        }

        const queryString = params.toString() ? `?${params}` : '';
        const response = await solicitudes.fetchRegistrosAuth(`/reporte/metodos-pago/${id_usuario}/${fechaInicio}/${fechaFin}${queryString}`);
        return response;
    } catch (error) {
        console.error('Error al obtener métodos de pago:', error);
        throw 'Ocurrió un error al obtener métodos de pago';
    }
};

export const getVentasPorPeriodo = async (id_usuario, fechaInicio, fechaFin, tipoPeriodo = 'diario') => {
    try {
        const params = new URLSearchParams({
            tipo_periodo: tipoPeriodo
        });

        const response = await solicitudes.fetchRegistrosAuth(`/reporte/ventas-por-periodo/${id_usuario}/${fechaInicio}/${fechaFin}?${params}`);
        return response;
    } catch (error) {
        console.error('Error al obtener ventas por período:', error);
        throw 'Ocurrió un error al obtener ventas por período';
    }
};

// ✅ FUNCIÓN PARA OBTENER VENTAS ANULADAS
export const getVentasAnuladas = async (id_usuario, fechaInicio, fechaFin, limite = 100, id_sucursal = null) => {
    try {
        const params = new URLSearchParams({
            limite: limite.toString()
        });

        // ✅ AGREGAR id_sucursal si existe
        if (id_sucursal) {
            params.append('id_sucursal', id_sucursal);
        }

        const response = await solicitudes.fetchRegistrosAuth(`/reporte/ventas-anuladas/${id_usuario}/${fechaInicio}/${fechaFin}?${params}`);
        return response;
    } catch (error) {
        console.error('Error al obtener ventas anuladas:', error);
        throw 'Ocurrió un error al obtener ventas anuladas';
    }
};

// ✅ CORRECCIÓN: Ventas Canceladas (alias de Ventas Anuladas)
export const getVentasCanceladas = async (id_usuario, fechaInicio, fechaFin, limite = 50, id_sucursal = null) => {
    try {
        const params = new URLSearchParams({
            limite: limite.toString()
        });

        // ✅ AGREGAR id_sucursal si existe
        if (id_sucursal) {
            params.append('id_sucursal', id_sucursal);
        }

        const response = await solicitudes.fetchRegistrosAuth(`/reporte/ventas-anuladas/${id_usuario}/${fechaInicio}/${fechaFin}?${params}`);
        return response;
    } catch (error) {
        console.error('Error al obtener ventas canceladas:', error);
        throw 'Ocurrió un error al obtener ventas canceladas';
    }
};

// Función para obtener datos de la institución
export const getDatosInstitucion = async (id_usuario, esCeo) => {
    let datosInstitucion;
    try {
        if(esCeo){
            const response = await getDatosEmpresas(id_usuario);
            datosInstitucion = {
                nombre: response.nombre,
                correo: response.correo_principal,
                telefono: response.telefono_principal,
                direccion: response.direccion,
                rtn: response.rtn,
                tipo: 'empresa'
            }
        } else {
            const response = await getDatosSucursal(id_usuario);
            datosInstitucion = {
                nombre: response.nombre_administrativo,
                correo: response.correo,
                telefono: response.telefono,
                direccion: response.direccion,
                tipo: 'sucursal'
            }
        }

        return datosInstitucion;

    } catch (error) {
        console.error(error);
        throw 'Ocurrió un error al obtener datos de la institución';
    }
}

// Función para obtener el reporte general de ventas (usando el nuevo endpoint mejorado)
export const getReporteVentasGeneral = async (filtros) => {
    try {
        const queryParams = new URLSearchParams({
            tipo_reporte: filtros.reporteSeleccionado,
            fecha_inicio: filtros.fechaInicio,
            fecha_fin: filtros.fechaFin,
            incluir_canceladas: filtros.incluirCanceladas?.toString() || 'false',
            ...(filtros.valorFiltro && { 
                [`id_${filtros.reporteSeleccionado.split('_')[1]}`]: filtros.valorFiltro 
            })
        }).toString();

        const response = await solicitudes.fetchRegistrosAuth(`/reporte/reporte?${queryParams}`);
        return response;
    } catch (error) {
        console.error('Error al obtener reporte general:', error);
        throw 'Ocurrió un error al obtener el reporte general';
    }
};

// Función para obtener estadísticas resumidas
export const getEstadisticasResumen = async (id_usuario, fechaInicio, fechaFin) => {
    try {
        const response = await solicitudes.fetchRegistrosAuth(`/reporte/estadisticas-resumen/${id_usuario}/${fechaInicio}/${fechaFin}`);
        return response;
    } catch (error) {
        console.error('Error al obtener estadísticas resumen:', error);
        throw 'Ocurrió un error al obtener estadísticas resumen';
    }
};

// Función para exportar reportes
export const exportarReporte = async (tipo, formato, filtros) => {
    try {
        const queryParams = new URLSearchParams({
            tipo_reporte: tipo,
            formato: formato,
            fecha_inicio: filtros.fechaInicio,
            fecha_fin: filtros.fechaFin,
            incluir_canceladas: filtros.incluirCanceladas?.toString() || 'false',
            limite: filtros.limite?.toString() || '50',
            ...(filtros.valorFiltro && { 
                [`id_${tipo.split('_')[1]}`]: filtros.valorFiltro 
            })
        }).toString();

        const response = await fetch(`${solicitudes.homeUrl}/reporte/exportar?${queryParams}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('auth')}`
            }
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status}`);
        }

        // Si es PDF o Excel, manejar como blob
        if (formato === 'pdf' || formato === 'excel') {
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `reporte_${tipo}_${new Date().toISOString().split('T')[0]}.${formato === 'pdf' ? 'pdf' : 'xlsx'}`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
            return { success: true };
        }

        return await response.json();
    } catch (error) {
        console.error('Error al exportar reporte:', error);
        throw 'Ocurrió un error al exportar el reporte';
    }
};

// Función para validar permisos de reporte
export const validarPermisosReporte = async (id_usuario, tipoReporte) => {
    try {
        const response = await solicitudes.fetchRegistrosAuth(`/reporte/validar-permisos/${id_usuario}/${tipoReporte}`);
        return response;
    } catch (error) {
        console.error('Error al validar permisos:', error);
        return { permitido: false, mensaje: 'Error al validar permisos' };
    }
};

// Función para obtener configuración de reportes del usuario
export const getConfiguracionReportes = async (id_usuario) => {
    try {
        const response = await solicitudes.fetchRegistrosAuth(`/reporte/configuracion/${id_usuario}`);
        return response;
    } catch (error) {
        console.error('Error al obtener configuración:', error);
        return {
            reportes_disponibles: ['ventas_cliente', 'ventas_sucursal', 'ventas_empleado'],
            formatos_exportacion: ['pdf', 'excel'],
            limites_permitidos: [20, 50, 100, 200]
        };
    }
};

// Función para guardar configuración de reportes
export const guardarConfiguracionReportes = async (id_usuario, configuracion) => {
    try {
        const response = await solicitudes.postRegistroAuth(`/reporte/configuracion/${id_usuario}`, configuracion);
        return response;
    } catch (error) {
        console.error('Error al guardar configuración:', error);
        throw 'Ocurrió un error al guardar la configuración';
    }
};

// Función para obtener historial de reportes generados
export const getHistorialReportes = async (id_usuario, limite = 10) => {
    try {
        const params = new URLSearchParams({
            limite: limite.toString()
        });

        const response = await solicitudes.fetchRegistrosAuth(`/reporte/historial/${id_usuario}?${params}`);
        return response;
    } catch (error) {
        console.error('Error al obtener historial:', error);
        return [];
    }
};

// Función para obtener reportes programados
export const getReportesProgramados = async (id_usuario) => {
    try {
        const response = await solicitudes.fetchRegistrosAuth(`/reporte/programados/${id_usuario}`);
        return response;
    } catch (error) {
        console.error('Error al obtener reportes programados:', error);
        return [];
    }
};

// Función para programar un reporte
export const programarReporte = async (id_usuario, configuracionReporte) => {
    try {
        const response = await solicitudes.postRegistroAuth(`/reporte/programar/${id_usuario}`, configuracionReporte);
        return response;
    } catch (error) {
        console.error('Error al programar reporte:', error);
        throw 'Ocurrió un error al programar el reporte';
    }
};

// Función para cancelar reporte programado
export const cancelarReporteProgramado = async (id_reporte_programado) => {
    try {
        const response = await solicitudes.deleteRegistroAuth(`/reporte/programado/${id_reporte_programado}`);
        return response;
    } catch (error) {
        console.error('Error al cancelar reporte programado:', error);
        throw 'Ocurrió un error al cancelar el reporte programado';
    }
};